<template>
  <div class="lcd-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>偏振光 + 液晶分子的电场扭转</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Light Path (Horizontal stack) -->
          <!-- Backlight -->
          <rect x="20" y="80" width="20" height="80" fill="#fff" opacity="0.4" />
          
          <!-- Polarizer 1 (Vertical) -->
          <g transform="translate(60, 120)">
             <rect x="-5" y="-40" width="10" height="80" fill="#222" />
             <line x1="0" y1="-30" x2="0" y2="30" stroke="#fff" stroke-width="2" />
             <text x="-15" y="-50" fill="#888" font-size="8">起偏器</text>
          </g>

          <!-- Liquid Crystal Layer -->
          <g transform="translate(150, 80)">
             <rect width="100" height="80" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" />
             <!-- Floating molecules -->
             <g v-for="i in 5" :key="i" :transform="`translate(${i*15}, 40)`">
                <ellipse rx="2" ry="10" fill="#ffd700" :transform="`rotate(${calcMolecule(i)})`" />
             </g>
             <text x="35" y="95" fill="#00d2ff" font-size="8">液晶层</text>
          </g>

          <!-- Polarizer 2 (Horizontal) -->
          <g transform="translate(320, 120)">
             <rect x="-5" y="-40" width="10" height="80" fill="#222" />
             <line x1="-15" y1="0" x2="15" y2="0" stroke="#fff" stroke-width="2" />
             <text x="-15" y="-50" fill="#888" font-size="8">检偏器</text>
          </g>

          <!-- Final Image result -->
          <rect x="360" y="100" width="30" height="40" :fill="finalLight" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ voltage > 50 ? '分子排列(电场开启) -> 阻断光线' : '分子扭曲(电场关闭) -> 透过光线' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>外加控制电压 (控制像素明暗)</label>
             <el-slider v-model="voltage" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>LCD显示屏利用了液晶分子的**旋光性**。在电场关闭时，液晶分子呈螺旋状排列，能将通过第一个偏振器的光旋转90度，从而顺利通过第二个正交的偏振器（屏幕发光）。当施加电压时，液晶分子被强行拉直不再旋转光线，光线被第二个偏振器挡住（屏幕变暗）。这就是液晶显示器开关每一个像素点的奥秘。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LCDPolarizationViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 0
    }
  },
  computed: {
    finalLight() {
       let intensity = 1 - (this.voltage / 100);
       return `rgba(255, 255, 255, ${intensity})`;
    }
  },
  methods: {
    calcMolecule(i) {
       // When voltage is low, high twist (range from 0 to 90)
       // When voltage is high, minimal twist (all vertical)
       return (1 - this.voltage/100) * (i * 18);
    }
  }
}
</script>

<style scoped lang="scss">
.lcd-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
